import { trackSignupTimeFromEmailToButtonTiming } from "@faire/web-api/events/signup/timing/timeFromEmailToButton";
import { TimingMarker } from "@faire/web/common/timings/TimingMarker";
import { useCallback, useRef } from "react";

export const useTrackEmailEntryAndSubmit = () => {
  const timingMarkerUserEntersEmail = useRef<TimingMarker | undefined>(
    undefined
  );

  const markUserEntersEmail = () => {
    if (!timingMarkerUserEntersEmail.current) {
      timingMarkerUserEntersEmail.current = new TimingMarker();
    }
  };

  const trackTimeBetweenEmailEntryAndSubmit = useCallback(() => {
    const end = new TimingMarker();
    if (timingMarkerUserEntersEmail.current) {
      trackSignupTimeFromEmailToButtonTiming({
        start: timingMarkerUserEntersEmail.current,
        end,
      });
    }
  }, []);

  return {
    markUserEntersEmail,
    trackTimeBetweenEmailEntryAndSubmit,
  };
};
